import { useCallback, useState } from 'react';
import { useReframe } from 'nike-re-framejs';

import { browserInfo } from '@/notifications/web-notification-browser';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { reqNotifyPermThenSync } from '@/notifications/init';
import { loggedIn$ } from '@/account/subs';

export default function useNotificationHandlerWrapper(info = browserInfo()) {
    const { browserGranted, browserSupported } = info;
    const { subscribe } = useReframe();
    const loggedIn = subscribe(loggedIn$);
    const [, repaint] = useState(0);
    const wrappedHandler = useCallback(
        handler => (...args) => {
            if (!loggedIn) {
                PopupNg.dispatcher.open('dialog/login4action', { bodyText: i18n('notifications.error.loggedIn') }, 20);
                return;
            }
            reqNotifyPermThenSync()
                .then(() => {
                    if (browserGranted) {
                        return handler(...args);
                    } else {
                        const info = browserInfo();
                        if (info.browserGranted) {
                            repaint(i => i + 1);
                            return handler(...args);
                        } else if (info.browserDenied) {
                            const bodyText = i18n('notifications.error.browserGranted');
                            PopupNg.dispatcher.open('dialog/message', { bodyText }, 20);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    repaint(i => i + 1);
                });
        },
        [browserGranted, loggedIn]
    );
    return { browserSupported, withRegisteredNotif: browserSupported ? wrappedHandler : null };
}
